// Centralized timezone data for the application
// Windows-style timezone format with friendly names

export const getTimezones = () => {
  return [
    { offset: -12, name: "(UTC-12:00) International Date Line West", iana: "Etc/GMT+12" },
    { offset: -11, name: "(UTC-11:00) Coordinated Universal Time-11", iana: "Etc/GMT+11" },
    { offset: -10, name: "(UTC-10:00) Hawaii", iana: "Pacific/Honolulu" },
    { offset: -9, name: "(UTC-09:00) Alaska", iana: "America/Anchorage" },
    { offset: -8, name: "(UTC-08:00) Pacific Time (US & Canada)", iana: "America/Los_Angeles" },
    { offset: -8, name: "(UTC-08:00) Baja California", iana: "America/Tijuana" },
    { offset: -7, name: "(UTC-07:00) Mountain Time (US & Canada)", iana: "America/Denver" },
    { offset: -7, name: "(UTC-07:00) Arizona", iana: "America/Phoenix" },
    { offset: -7, name: "(UTC-07:00) Chihuahua, La Paz, Mazatlan", iana: "America/Chihuahua" },
    { offset: -6, name: "(UTC-06:00) Central Time (US & Canada)", iana: "America/Chicago" },
    { offset: -6, name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey", iana: "America/Mexico_City" },
    { offset: -6, name: "(UTC-06:00) Saskatchewan", iana: "America/Regina" },
    { offset: -6, name: "(UTC-06:00) Central America", iana: "America/Guatemala" },
    { offset: -5, name: "(UTC-05:00) Eastern Time (US & Canada)", iana: "America/New_York" },
    { offset: -5, name: "(UTC-05:00) Bogota, Lima, Quito", iana: "America/Bogota" },
    { offset: -5, name: "(UTC-05:00) Indiana (East)", iana: "America/Indianapolis" },
    { offset: -4.5, name: "(UTC-04:30) Caracas", iana: "America/Caracas" },
    { offset: -4, name: "(UTC-04:00) Atlantic Time (Canada)", iana: "America/Halifax" },
    { offset: -4, name: "(UTC-04:00) Asuncion", iana: "America/Asuncion" },
    { offset: -4, name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan", iana: "America/La_Paz" },
    { offset: -4, name: "(UTC-04:00) Cuiaba", iana: "America/Cuiaba" },
    { offset: -4, name: "(UTC-04:00) Santiago", iana: "America/Santiago" },
    { offset: -3.5, name: "(UTC-03:30) Newfoundland", iana: "America/St_Johns" },
    { offset: -3, name: "(UTC-03:00) Brasilia", iana: "America/Sao_Paulo" },
    { offset: -3, name: "(UTC-03:00) Buenos Aires", iana: "America/Argentina/Buenos_Aires" },
    { offset: -3, name: "(UTC-03:00) Cayenne, Fortaleza", iana: "America/Cayenne" },
    { offset: -3, name: "(UTC-03:00) Greenland", iana: "America/Godthab" },
    { offset: -3, name: "(UTC-03:00) Montevideo", iana: "America/Montevideo" },
    { offset: -2, name: "(UTC-02:00) Coordinated Universal Time-02", iana: "Etc/GMT+2" },
    { offset: -1, name: "(UTC-01:00) Azores", iana: "Atlantic/Azores" },
    { offset: -1, name: "(UTC-01:00) Cape Verde Is.", iana: "Atlantic/Cape_Verde" },
    { offset: 0, name: "(UTC) Dublin, Edinburgh, Lisbon, London", iana: "Europe/London" },
    { offset: 0, name: "(UTC) Monrovia, Reykjavik", iana: "Atlantic/Reykjavik" },
    { offset: 0, name: "(UTC) Casablanca", iana: "Africa/Casablanca" },
    { offset: 0, name: "(UTC) Coordinated Universal Time", iana: "Etc/UTC" },
    { offset: 1, name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", iana: "Europe/Berlin" },
    { offset: 1, name: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris", iana: "Europe/Paris" },
    { offset: 1, name: "(UTC+01:00) West Central Africa", iana: "Africa/Lagos" },
    { offset: 1, name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", iana: "Europe/Budapest" },
    { offset: 1, name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb", iana: "Europe/Warsaw" },
    { offset: 2, name: "(UTC+02:00) Athens, Bucharest", iana: "Europe/Bucharest" },
    { offset: 2, name: "(UTC+02:00) Cairo", iana: "Africa/Cairo" },
    { offset: 2, name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", iana: "Europe/Kiev" },
    { offset: 2, name: "(UTC+02:00) Jerusalem", iana: "Asia/Jerusalem" },
    { offset: 2, name: "(UTC+02:00) Harare, Pretoria", iana: "Africa/Johannesburg" },
    { offset: 2, name: "(UTC+02:00) Istanbul", iana: "Europe/Istanbul" },
    { offset: 3, name: "(UTC+03:00) Kuwait, Riyadh", iana: "Asia/Riyadh" },
    { offset: 3, name: "(UTC+03:00) Baghdad", iana: "Asia/Baghdad" },
    { offset: 3, name: "(UTC+03:00) Nairobi", iana: "Africa/Nairobi" },
    { offset: 3, name: "(UTC+03:00) Moscow, St. Petersburg, Volgograd", iana: "Europe/Moscow" },
    { offset: 3.5, name: "(UTC+03:30) Tehran", iana: "Asia/Tehran" },
    { offset: 4, name: "(UTC+04:00) Abu Dhabi, Muscat", iana: "Asia/Dubai" },
    { offset: 4, name: "(UTC+04:00) Baku", iana: "Asia/Baku" },
    { offset: 4, name: "(UTC+04:00) Yerevan", iana: "Asia/Yerevan" },
    { offset: 4, name: "(UTC+04:00) Tbilisi", iana: "Asia/Tbilisi" },
    { offset: 4.5, name: "(UTC+04:30) Kabul", iana: "Asia/Kabul" },
    { offset: 5, name: "(UTC+05:00) Islamabad, Karachi", iana: "Asia/Karachi" },
    { offset: 5, name: "(UTC+05:00) Tashkent", iana: "Asia/Tashkent" },
    { offset: 5.5, name: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", iana: "Asia/Kolkata" },
    { offset: 5.5, name: "(UTC+05:30) Sri Jayawardenepura", iana: "Asia/Colombo" },
    { offset: 5.75, name: "(UTC+05:45) Kathmandu", iana: "Asia/Kathmandu" },
    { offset: 6, name: "(UTC+06:00) Astana", iana: "Asia/Almaty" },
    { offset: 6, name: "(UTC+06:00) Dhaka", iana: "Asia/Dhaka" },
    { offset: 6.5, name: "(UTC+06:30) Yangon (Rangoon)", iana: "Asia/Yangon" },
    { offset: 7, name: "(UTC+07:00) Bangkok, Hanoi, Jakarta", iana: "Asia/Bangkok" },
    { offset: 7, name: "(UTC+07:00) Novosibirsk", iana: "Asia/Novosibirsk" },
    { offset: 8, name: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", iana: "Asia/Shanghai" },
    { offset: 8, name: "(UTC+08:00) Kuala Lumpur, Singapore", iana: "Asia/Singapore" },
    { offset: 8, name: "(UTC+08:00) Perth", iana: "Australia/Perth" },
    { offset: 8, name: "(UTC+08:00) Taipei", iana: "Asia/Taipei" },
    { offset: 8, name: "(UTC+08:00) Ulaanbaatar", iana: "Asia/Ulaanbaatar" },
    { offset: 9, name: "(UTC+09:00) Osaka, Sapporo, Tokyo", iana: "Asia/Tokyo" },
    { offset: 9, name: "(UTC+09:00) Seoul", iana: "Asia/Seoul" },
    { offset: 9.5, name: "(UTC+09:30) Adelaide", iana: "Australia/Adelaide" },
    { offset: 9.5, name: "(UTC+09:30) Darwin", iana: "Australia/Darwin" },
    { offset: 10, name: "(UTC+10:00) Brisbane", iana: "Australia/Brisbane" },
    { offset: 10, name: "(UTC+10:00) Canberra, Melbourne, Sydney", iana: "Australia/Sydney" },
    { offset: 10, name: "(UTC+10:00) Guam, Port Moresby", iana: "Pacific/Port_Moresby" },
    { offset: 10, name: "(UTC+10:00) Hobart", iana: "Australia/Hobart" },
    { offset: 10, name: "(UTC+10:00) Yakutsk", iana: "Asia/Yakutsk" },
    { offset: 11, name: "(UTC+11:00) Solomon Is., New Caledonia", iana: "Pacific/Guadalcanal" },
    { offset: 12, name: "(UTC+12:00) Auckland, Wellington", iana: "Pacific/Auckland" },
    { offset: 12, name: "(UTC+12:00) Fiji", iana: "Pacific/Fiji" },
    { offset: 12, name: "(UTC+12:00) Coordinated Universal Time+12", iana: "Etc/GMT-12" },
    { offset: 13, name: "(UTC+13:00) Nuku'alofa", iana: "Pacific/Tongatapu" },
  ];
};

// Get only timezone names for dropdown
export const getTimezoneNames = () => {
  return getTimezones().map(tz => tz.name);
};

// Get timezone by name
export const getTimezoneByName = (name) => {
  return getTimezones().find(tz => tz.name === name);
};

// Get timezone by IANA identifier
export const getTimezoneByIana = (iana) => {
  return getTimezones().find(tz => tz.iana === iana);
};
